import React, {useState, useEffect} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import '../App.css';
import SocialIcons from "./SocialIcons";

interface MenuProps {
    isOpen: boolean;
    onClose: () => void;
}

const MENU_ITEMS = [
    { id: 'home', label: '홈', icon: '/home-icon.svg', path: '/', disabled: false },
    { id: 'guide', label: '가이드', icon: '/guide-icon.svg', path: '/guide', disabled: false },
    { id: 'lyrics-practice', label: '가사 퀴즈', icon: '/lyrics-icon-filled.svg', path: '/lyrics-practice', disabled: false },
    // { id: 'lv4', label: 'LV4', icon: '/lv4-icon.svg', path: '/lv4', disabled: false },
    { id: 'chart', label: '차트', icon: '/chart-icon.svg', path: '/chart', disabled: false },
    { id: 'event', label: '이벤트', icon: '/event-icon.svg', path: '/event', disabled: false },
];

const Menu: React.FC<MenuProps> = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isClosing, setIsClosing] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setIsClosing(false);
        }
    }, [isOpen]);

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShouldRender(false);
            onClose();
        }, 250);
    };

    const handleMenuClick = (item: typeof MENU_ITEMS[0]) => {
        if (!item.disabled) {
            setIsClosing(true);
            setTimeout(() => {
                navigate(item.path);
                setShouldRender(false);
                onClose();
            }, 250);
        }
    };

    if (!shouldRender) return null;

    return (
        <div className={`menu-overlay ${isClosing ? 'closing' : ''}`}>
            <div className="menu-header">
                <button className="menu-close-button" onClick={handleClose}>
                    <img src={process.env.PUBLIC_URL + '/close-icon.svg'} alt="Close" className="menu-close-icon"/>
                </button>
            </div>
            <div className="menu-content">
                <nav className="menu-nav">
                    {MENU_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`menu-nav-item ${isActive(item.path) ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                            onClick={() => handleMenuClick(item)}
                        >
                            <img
                                src={process.env.PUBLIC_URL + item.icon}
                                alt={item.label}
                                className="menu-nav-icon"
                            />
                            <span className="menu-nav-text">{item.label}</span>
                        </div>
                    ))}
                </nav>
                <div className="menu-footer">
                    <SocialIcons />
                    <p className="menu-copyright">© 김성규 음원총공팀 sungkyustream 2025</p>
                </div>
            </div>
        </div>
    );
};

export default Menu;
